<template>
  <div>
    <h1>個人毎施設毎労働時間集計Excel出力</h1>
    <v-card outlined class="mb-5">
      <v-expansion-panels flat v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="headline"></span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- 主現場選択 -->
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="selectAffiliation"
                  :items="filterAffiliations"
                  label="対象施設"
                  outlined
                  clearable
                  multiple
                  chips
                  item-text="name"
                  item-value="code"
                />
              </v-col>
            </v-row>
            <!-- 対象期間 -->
            <v-row>
              <v-col cols="12" sm="6">
                <DatePicker
                  v-model="attendanceDateFrom"
                  label="期間From"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                />
              </v-col>
              <v-col cols="12" sm="6">
                <DatePicker
                  v-model="attendanceDateTo"
                  label="期間To"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                />
              </v-col>
            </v-row>
            <!-- 有給時間を含む -->
            <!-- <v-row>
              <v-col cols="12">
                <v-checkbox v-model="includePaidLeave" label="有給時間を含む" />
              </v-col>
            </v-row> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions class="mx-2">
        <p style="color:red">
          対象年月に実績が無い場合は、出力されません。
        </p>
        <p style="color:red">
          また、超過時間は所定労働時間を超えたものは、表示されていません。
        </p>
        <v-spacer></v-spacer>
        <Btn
          color="success"
          icon="mdi-download"
          @click="exportExcel"
          :disabled="!canDownload"
        >
          Excel出力
        </Btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";
import Forms from "@/mixins/forms";
import Api from "@/mixins/api";
import DatePicker from "@/components/DatePicker";
import Btn from "@/components/Button";

export default {
  name: "WorkTimeSummary",
  mixins: [Common, ShowDialogs, Forms, Api],
  components: {
    DatePicker,
    Btn
  },
  data() {
    return {
      panel: 0,
      selectAffiliation: [],
      attendanceDateFrom: "",
      attendanceDateTo: "",
      filterAffiliations: [],
      includePaidLeave: false
    };
  },
  computed: {
    canDownload() {
      return (
        this.selectAffiliation.length > 0 &&
        this.attendanceDateFrom !== "" &&
        this.attendanceDateTo !== ""
      );
    }
  },
  methods: {
    initializeDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const day = today.getDate();

      // システム日付に基づいて期間を設定
      if (day >= 1 && day <= 15) {
        // 前月16日から当月15日
        const fromDate = new Date(year, month - 1, 16);
        const toDate = new Date(year, month, 15);

        this.attendanceDateFrom = this.formatDate(fromDate);
        this.attendanceDateTo = this.formatDate(toDate);
      } else {
        // 当月16日から翌月15日
        const fromDate = new Date(year, month, 16);
        const toDate = new Date(year, month + 1, 15);

        this.attendanceDateFrom = this.formatDate(fromDate);
        this.attendanceDateTo = this.formatDate(toDate);
      }
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    async exportExcel() {
      if (!this.canDownload) {
        this.$error("必須項目を入力してください。");
        return;
      }

      // 日付の妥当性チェック
      if (this.attendanceDateFrom > this.attendanceDateTo) {
        this.$error("期間の開始日は終了日より前の日付を指定してください。");
        return;
      }

      try {
        this.$loading();
        const param = {
          affiliation: this.selectAffiliation,
          attendanceDateFrom: this.attendanceDateFrom,
          attendanceDateTo: this.attendanceDateTo,
          includePaidLeave: this.includePaidLeave
        };

        const encode = encodeURI(JSON.stringify(param));

        const result = await this.$downloadexcel(
          this.Paths.worktimeSummary,
          "query=" + encode
        );
        const url = URL.createObjectURL(result);

        // ファイルダウンロード
        const link = document.createElement("a");
        link.href = url;
        link.download = `個人毎施設毎労働時間集計_${this.attendanceDateFrom.replace(
          /-/g,
          ""
        )}_${this.attendanceDateTo.replace(/-/g, "")}.xlsx`;
        link.click();
      } catch (e) {
        this.$error("Excel出力に失敗しました。");
      } finally {
        this.$unloading();
      }
    }
  },

  async created() {
    console.log("==created WorktimeSummary");
    this.initializeDates();

    try {
      this.$loading();
      // 他のページと同様にshozokuFilterForCalcを使用
      this.filterAffiliations = await this.$get(
        this.Paths.shozokuFilterForCalc
      );
      console.log("取得した所属データ:", this.filterAffiliations);

      // データの構造を確認
      if (this.filterAffiliations && this.filterAffiliations.length > 0) {
        console.log("最初の所属データのサンプル:", this.filterAffiliations[0]);
      }
    } catch (e) {
      console.error("所属データ取得エラー:", e);
      this.$error("所属データの取得に失敗しました。");
      // エラーの場合は空配列を設定
      this.filterAffiliations = [];
    } finally {
      this.$unloading();
    }
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}
</style>
